import { gql } from "@apollo/client";

export const AssessmentGroupListFragment = gql`
  fragment AssessmentGroupListFragment on AssessmentGroupNode {
    id
    title
    created
    archived
    assessmentType
    isOnlySelfAssessment
    hasNpsQuestions
    creator {
      id
      name
    }
    canUpdate {
      permission
      reason
    }
    canDelete {
      permission
      reason
    }
  }
`;
export default gql`
  ${AssessmentGroupListFragment}
  query getAssessmentGroupsList($organizationId: Int!, $archived: Boolean) {
    assessmentGroups(organizationId: $organizationId, archived: $archived) {
      edges {
        node {
          ...AssessmentGroupListFragment
        }
      }
    }
  }
`;
